import { Accordion, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";
// import DataTable from "datatables.net-bs5";
import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
// import Datepickers from '../../../components/Datepickers.js';
// import { get } from "sortablejs";
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import LeaveViewModal from "./LeaveViewModal";
import { allUsersSignal } from "../../../signal/allUsersSignal";

export default function LeavesList() {

    let today = Date.now();
    today = new Date(today).setHours(0, 0, 0, 0);
    let fifteenDaysAgo = new Date(today - 15 * 24 * 60 * 60 * 1000).getTime();
    let fifteenDaysFuture = new Date(today + 15 * 24 * 60 * 60 * 1000).getTime();

    const [searchParams, setSearchParams] = useSearchParams();
    const [leaves, setLeaves] = useState([]);
    const [leavesToDisplay, setLeavesToDisplay] = useState([]);
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(fifteenDaysAgo).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(fifteenDaysFuture).format("YYYY-MM-DD"));
    const [search, setSearch] = useState("");
    const [text, setText] = useState({})
    const [statusFilter, setStatusFilter] = useState(searchParams.get("statusFilter") ? searchParams.get("statusFilter") : "");
    const [selectedLeave, setSelectedLeave] = useState(null)
    const [leaveModalShow, setLeaveModalShow] = useState(false);

    useEffect(() => {
        if (searchParams.get("search")) {
            setSearch(searchParams.get("search"));
        }
    }, [])

    const handleDisplayFields = () => {
        setLeavesToDisplay(leaves.filter((item) => {
            if (statusFilter && statusFilter !== "" && item.status !== statusFilter) return false;
            if (search === "") return true;
            if (item.id.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item.reason.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.userId?.length > 0 && item.userId[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.status.toLowerCase().startsWith(search.toLowerCase())) {
                return true;
            } else if (item.reviewedBy?.length > 0 && item.reviewedBy[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.review.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (moment(item.startTime).format("DD/MM/YY hh:mm").includes(search.toLowerCase())) {
                return true;
            } else if (moment(item.endTime).format("DD/MM/YY hh:mm").includes(search.toLowerCase())) {
                return true;
            }
            return false;
        }))
    }

    const refetchLeaves = () => {
        getLeaves.refetch({ cancelRefetch: true });
    }

    const handleFilters = async () => {
        const tempSearchParam = new URLSearchParams({ fromDate: fromDate, toDate, statusFilter});
        setSearchParams(tempSearchParam);
        await refetchLeaves();
        handleDisplayFields();
    }

    useEffect(() => {
        handleDisplayFields()
    }, [search, leaves])

    const getLeaves = useQuery("leaves", async () => {
        let resp = await axios.get(`${DEV_SERVER}/leave/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                let stateName = window.localStorage.getItem("state");
                let temp = data.data
                if(stateName){
                    temp = temp.filter((item) => {
                        if(item?.userId?.length && allUsersSignal.value[item?.userId[0]?.id]?.state === stateName){
                            return true;
                        }else{
                            return false;
                        }
                    });
                }

                setLeaves(temp);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const updateLeaveStatusMutation = useMutation((data) => axios.put(`${DEV_SERVER}/leave/v2/updateLeaveStatus/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            if (data.status) {
                toast.success(data.message);
                refetchLeaves();
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    let updateLeavesStatus = (id, status, review) => {
        updateLeaveStatusMutation.mutate({ id, body: { status, review } })
    }

    useEffect(() => {
        refetchLeaves();
    }, [])

    const handleRowClick = (row) => {
        setSelectedLeave(row);
        setLeaveModalShow(true);
    }

    const columns = [
        {
            name: "Reason",
            color: true,
            selector: "reason",
            cell: (row) => <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reason}</Tooltip>}>
                <span onClick={() => handleRowClick(row)}>{row?.reason}</span>
            </OverlayTrigger>

        },
        {
            name: "Start Date",
            sortable: true,
            color: true,
            selector: "startTime",
            cell: (row) => moment(row?.startTime).format("DD/MM/YY hh:mm a")
        },
        {
            name: "End Date",
            sortable: true,
            color: true,
            selector: "endTime",
            cell: (row) => moment(row?.endTime).format("DD/MM/YY hh:mm a")
        },
        {
            name: "User",
            color: true,
            selector: (row) => {
                if (row?.userId?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.userId[0]?.name}</Tooltip>}>
                        <span onClick={() => handleRowClick(row)} style={{ display: "flex", columnGap: "0.5rem", alignItems: "center" }}>
                            <img style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={row?.userId[0].profileURL !== "" ? row?.userId[0].profileURL : avatar1} />
                            <p style={{ margin: "0px" }}>{row?.userId[0].name}</p>
                        </span>
                    </OverlayTrigger>
                }
                return "NA"
            }
        },
        {
            name: "Status",
            sortable: true,
            color: true,
            selector: (row) => <span style={{ color: row?.status === "pending" ? "red" : (row?.status === "approved" ? "green" : "orange") }}>{row?.status}</span>
        },
        {
            name: "Reviewed By",
            color: true,
            selector: (row) => {
                if (row?.reviewedBy?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reviewedBy[0]?.name}</Tooltip>}>
                        <span onClick={() => handleRowClick(row)}>{row?.reviewedBy[0]?.name}</span>
                    </OverlayTrigger>
                }
                return "NA"
            }
        },
        {
            name: "Review",
            color: true,
            selector: (row) => {
                if (row?.status === "pending") {
                    return <textarea style={{ width: "100%" }} value={text[row?.id] || ""} onChange={(e) => setText({ ...text, [row?.id]: e.target.value })} ></textarea>
                } else {
                    return row?.review === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reason}</Tooltip>}><span>{row?.review}</span></OverlayTrigger>
                }
            }
        },
        {
            name: "Action",
            color: true,
            selector: (row) => {
                return <span style={{ display: "flex", alignItems: "center", justifyContent: "center", columnGap: "0.8rem", opacity: row?.status === "pending" ? 1 : 0.5 }}>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Reject</Tooltip>}><i onClick={(e) => updateLeavesStatus(row?.id, "rejected", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "red" }} class="fas fa-times"></i></OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Approve</Tooltip>}><i onClick={(e) => updateLeavesStatus(row?.id, "approved", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "green" }} class="fas fa-check"></i></OverlayTrigger>
                </span>
            }
        }

    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Leaves List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Filters</Accordion.Header>
                                        <Accordion.Body>
                                            <div style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem" }}>
                                                <div>
                                                    <label htmlFor="fromDate">From Date</label>
                                                    <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" value={fromDate} onChange={(e) => {
                                                        setFromDate(e.target.value);
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="toDate">To Date</label>
                                                    <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" value={toDate} onChange={(e) => {
                                                        setToDate(e.target.value);
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="status">Status</label>
                                                    <select id="status" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={statusFilter} onChange={(e) => {
                                                        setStatusFilter(e.target.value);
                                                    }}>
                                                        <option value="">All</option>
                                                        <option value="pending">Pending</option>
                                                        <option value="approved">Approved</option>
                                                        <option value="rejected">Rejected</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setFromDate(moment(fifteenDaysAgo).format("YYYY-MM-DD"));
                                                    setToDate(moment(fifteenDaysFuture).format("YYYY-MM-DD"));
                                                    setStatusFilter("");
                                                    const tempSearchParam = new URLSearchParams({ fromDate: moment(fifteenDaysAgo).format("YYYY-MM-DD"), toDate: moment(fifteenDaysFuture).format("YYYY-MM-DD"), statusFilter: "" });
                                                    setSearchParams(tempSearchParam);
                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                <div className="mt-3" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", columnGap: "1rem", marginBottom: "1rem" }}>
                                    <div>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => {
                                            setSearch(e.target.value);
                                        }} />
                                    </div>
                                </div>
                                {(!getLeaves.isLoading && !getLeaves?.isFetching) && <DataTable
                                    columns={columns}
                                    data={leavesToDisplay}
                                    pagination={true}
                                    onRowClicked={(row) => {
                                        handleRowClick(row);
                                    }}
                                    customStyles={
                                        {
                                            rows: {
                                                style: {
                                                    cursor: "pointer",
                                                    backgroundColor: "unset"
                                                }
                                            }
                                        }
                                    }
                                />}
                                {(getLeaves.isLoading || getLeaves?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {leaveModalShow && <LeaveViewModal updateLeavesStatus={updateLeavesStatus} show={leaveModalShow} close={() => setLeaveModalShow(false)} leave={selectedLeave} />}
        </>
    )
}